/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import chainOnEnter from 'components/lib/chainOnEnter';
import DialogContent from 'components/DialogContent.jsx';
import PasswordForm from 'components/PasswordForm.jsx';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';

class SetupPassword extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static onEnter = chainOnEnter([RequireUser])

  onSave = () => {
    this.context.router.push('/classes');
  }

  render() {
    return (
      <DialogContent
        size="small"
        full
        title={'Create a password'}
        subtext={'Your password must consist of at least six characters.'}>
        <BoxBody>
          <PasswordForm onSave={this.onSave} />
        </BoxBody>
      </DialogContent>
    );
  }
}

export default SetupPassword;



// WEBPACK FOOTER //
// ./src/setup/components/SetupPassword.jsx